import { render, staticRenderFns } from "./GridSettingsWrapper.vue?vue&type=template&id=bf569cc2&"
import script from "./GridSettingsWrapper.vue?vue&type=script&lang=js&"
export * from "./GridSettingsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports